import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Rating from '@material-ui/lab/Rating';
import { userContext } from 'contexts/userContext';
import { tabContext } from 'contexts/tabContext';
import { RATING_TAB_ID } from 'settings/productV2';
import { gtmAfiEventLab } from 'services/gtm';
import { ProductReviewsRatingType } from 'types/ProductPageV2/ProductReviews';
import styles from './ProductRating.module.scss';

/**
 * Product page of website. Contains rating product data.
 */
function ProductRating({
  rating,
  modelName,
  realSku,
}: {
  rating: ProductReviewsRatingType;
  modelName: string;
  realSku: string;
}): JSX.Element {
  const { pathname } = useLocation();
  const { gtmUserCookie } = useContext(userContext);
  const { setIdTab, scrollToTabs } = useContext(tabContext);
  const { rate, count } = rating;
  const rateRound = parseFloat(rate).toFixed(1);

  return (
    <div
      onClick={() => {
        gtmAfiEventLab(
          pathname,
          'afiEventLab',
          'Page produit',
          'Clic avis client',
          gtmUserCookie,
          `${realSku} - ${modelName}`
        );
        setIdTab(RATING_TAB_ID);
        scrollToTabs(RATING_TAB_ID);
      }}
      className={styles.productRating}
    >
      <Rating
        size={'large'}
        className={styles.stars}
        value={parseFloat(rateRound)}
        precision={0.1}
        readOnly
      />
      <div className={styles.rateValueContainer}>
        <span className={styles.rate}>{rateRound}</span>&nbsp;
        <span className={styles.count}>({count})</span>
      </div>
    </div>
  );
}

export default ProductRating;
